var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "qc-review" },
    [
      _c(
        "el-table",
        {
          staticStyle: { width: "100%", "margin-bottom": "20px" },
          attrs: { data: _vm.checkOrderDetailVoList, border: "" },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "checkOrderCode", label: "查货编号" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "checkResultName", label: "查货结果" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "dealModeName", label: "处理方式" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "createDate", label: "查货时间" },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { prop: "", label: "质检报告" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.fileName !== null
                      ? _c("div", { staticClass: "file" }, [
                          _c(
                            "span",
                            {
                              staticClass: "fileName",
                              on: {
                                click: function ($event) {
                                  return _vm.previewFile(
                                    scope.row.inspectionReport
                                  )
                                },
                              },
                            },
                            [_vm._v(_vm._s(scope.row.fileName))]
                          ),
                          _vm._v(" "),
                          _c("i", {
                            staticClass: "iconfont iconmain-download",
                            on: {
                              click: function ($event) {
                                return _vm.uploadFile(scope.row.fileId)
                              },
                            },
                          }),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.dialogVisible,
            title: "图片详情",
            center: "",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("img", {
            attrs: {
              width: "100%",
              src: _vm._f("picFilter")(_vm.dialogImageUrl, { size: "large" }),
              alt: "",
            },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }